import { ManifestsTab } from "pages/AppManifests/_shared";

import { DetailsTabProps } from "../types";

export function TiVoAppDetailsManifestsTab({ provider }: DetailsTabProps) {
  return <ManifestsTab appId={provider.providerId} />;
}
